export default __webpack_public_path__ + "static/media/display2.31f44296.png";